export default __webpack_public_path__ + "static/video_wise-1a37935f1ffd43b97adaff9338037cfd.svg";